import React from 'react'
import styles from '../styles/ChatterWelcome.module.css'

const ChatterWelcome: React.FC = () => {
  return (
    <div className={styles.welcomeContainer}>
      <div className={styles.welcomeContent}>
        <div className={styles.welcomeIcon}>💬</div>
        <h1 className={styles.welcomeTitle}>Welcome to Chatter</h1>
        <p className={styles.welcomeDescription}>
          Select a conversation from the sidebar to start chatting with your clients about their deals.
        </p>
        <div className={styles.features}>
          <div className={styles.feature}>
            <div className={styles.featureIcon}>📨</div>
            <div className={styles.featureText}>
              <h3>Real-time Messaging</h3>
              <p>Chat instantly with your clients about their applications</p>
            </div>
          </div>
          <div className={styles.feature}>
            <div className={styles.featureIcon}>📎</div>
            <div className={styles.featureText}>
              <h3>File Sharing</h3>
              <p>Share documents and files securely within conversations</p>
            </div>
          </div>
          <div className={styles.feature}>
            <div className={styles.featureIcon}>🔔</div>
            <div className={styles.featureText}>
              <h3>Notifications</h3>
              <p>Stay updated with unread message indicators and alerts</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ChatterWelcome
